import { getEmailLogs } from "../../../../../actions/Utilities/EmailLogs";
import { useQuery } from "react-query";

export default function useEmailLogs() {
  return useQuery("GetEmailLogs", getEmailLogs, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
